module.exports = __webpack_public_path__ + "static/customer_danal_logo-e2af66361b7b561401ec95608f8ba97b.svg";